export default "__VITE_ASSET__B$ruFZom__"